import { render, staticRenderFns } from "./printerinfo.vue?vue&type=template&id=153f9657&"
import script from "./printerinfo.vue?vue&type=script&lang=js&"
export * from "./printerinfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports